<div
  #container
  [ngStyle]="{
    fontSize: (currentFontSize$ | async) + 'px'
  }"
>
  {{ name }}
</div>
<span
  [ngStyle]="{
    fontSize: (currentFontSize$ | async) + 'px'
  }"
>
  {{ name }}
</span>
